/* eslint-disable max-len */
import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SegmentService} from '../../segment/segment.service';
import {Segment, SegmentModel} from '../../segment/segment.model';
import {FormControl} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {TargetService} from '../../target/target.service';
import {NotificationService} from '../../utils/notification-service';
import {ApiId, DistributionAccountModel, TargetSystemId} from '../../distribution-account/distribution-account.model';
import {AppStore} from '../../store/store';
import {partnerForIdSelector} from '../../partner/partner.reducer';
import {userSelector} from '../../user/user.reducer';
import {MatStepper} from '@angular/material/stepper';
import {PartnerModel} from '../../partner/partner.model';
import {
  AdditionalSharingConfigBase,
  PubmaticShareConfig,
  SegmentShareService,
  TargetSystem
} from '../segment-share.service';
import {first} from 'rxjs/operators';
import {BehaviorSubject, combineLatest, ReplaySubject} from 'rxjs';
import {AccountConfigurationSystemId, ShareResult,} from '../domain';
import {MultiShareValidationService} from '../multi-share-validation.service';
import {SubSink} from 'subsink';
import {
  PubmaticEditConfig
} from '../../segment/info/shared-targets-list/account-pubmatic/account-pubmatic-edit-wrapper.component';
import {StepperSelectionEvent} from '@angular/cdk/stepper';
import {Store} from '@ngrx/store';
import {selectTargets} from '../../target/target.state';
import {MatButtonToggleChange} from '@angular/material/button-toggle';

interface TargetAccountForDisplay {
  targetId: number | AccountConfigurationSystemId;
  foreignAccountId: string;
  targetName: string;
  accountName: string;
  accountId: number;
  apiId: ApiId;
}

@Component({
  selector: 'app-segment-multi-share',
  template: `
      <div [style.visibility]="loading ? 'visible' : 'hidden'" class="loading-progress-bar">
          <mat-progress-bar mode="query"></mat-progress-bar>
      </div>

      <div class="main" style="margin-top: -4px;">
          <mat-horizontal-stepper (selectionChange)="onStep($event)" linear #stepper>
              <mat-step>
                  <ng-template matStepLabel>Confirm selected partner</ng-template>
                  <div class="rowWrap step1" *ngIf="partner">
                      <div class="rowItem">
                          <h5>Check selected partner</h5>
                          <mat-checkbox [formControl]="partnerSelectedControl" [disabled]="loading">
                              Is the current selected partner <b>{{partner.name}}</b> correct?
                          </mat-checkbox>
                      </div>
                  </div>
                  <div class="stepper-actions step1">
                      <button mat-button matStepperNext [disabled]="!partnerSelectedControl.value">Next</button>
                  </div>
              </mat-step>
              <mat-step>
                  <ng-template matStepLabel>Select segments</ng-template>
                  <div class="rowWrap step2">
                      <div *ngIf="stepIndex===1" class="rowItem search">
                          <h5>Search segments</h5>
                          <mat-form-field>
                              <input [formControl]="segmentsFilterControl" matInput name="input-segment-search"
                                     placeholder="Search a segment by name, ID, eID"
                                     [autofocus]="true"/>
                          </mat-form-field>
                          <div class="tableWrapper">
                              <table mat-table [dataSource]="filteredSegmentsDataSource.filteredData|slice:0:5"
                                     class="mat-elevation-z0"
                                     *ngIf="showFilteredSegments()">
                                  <ng-container matColumnDef="id">
                                      <th mat-header-cell *matHeaderCellDef> Id</th>
                                      <td mat-cell *matCellDef="let element"> {{element['id']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="eid">
                                      <th mat-header-cell *matHeaderCellDef> eId</th>
                                      <td mat-cell *matCellDef="let element"> {{element['clientSideId']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="name">
                                      <th mat-header-cell *matHeaderCellDef> Name</th>
                                      <td mat-cell *matCellDef="let element"> {{element['name']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="add">
                                      <th mat-header-cell *matHeaderCellDef></th>
                                      <td mat-cell *matCellDef="let element" class="listAction">
                                          <mat-icon matTooltip="Select Segment">add</mat-icon>
                                      </td>
                                  </ng-container>

                                  <tr mat-header-row *matHeaderRowDef="['id', 'eid', 'name', 'add']"></tr>
                                  <tr mat-row *matRowDef="let row; columns: ['id', 'eid', 'name', 'add'];"
                                      (click)="addSegment(row)"></tr>
                              </table>
                          </div>
                          <div class="emptyTableMessage" *ngIf="!showFilteredSegments()">No segments found</div>
                      </div>
                      <div class="rowItem select">
                          <h5>Selected segments ({{selectedSegmentsDataSource.data.length}})</h5>
                          <div *ngIf="stepIndex===1" class="tableWrapper selectedItems">
                              <table mat-table [dataSource]="selectedSegmentsDataSource" class="mat-elevation-z0"
                                     *ngIf="showSelectedSegments()">
                                  <ng-container matColumnDef="id">
                                      <th mat-header-cell *matHeaderCellDef> Id</th>
                                      <td mat-cell *matCellDef="let element"> {{element['id']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="eid">
                                      <th mat-header-cell *matHeaderCellDef> eId</th>
                                      <td mat-cell *matCellDef="let element"> {{element['clientSideId']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="name">
                                      <th mat-header-cell *matHeaderCellDef> Name</th>
                                      <td mat-cell *matCellDef="let element"> {{element['name']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="remove">
                                      <th mat-header-cell *matHeaderCellDef></th>
                                      <td mat-cell *matCellDef="let element" class="listAction">
                                          <mat-icon matTooltip="Remove Segment">remove</mat-icon>
                                      </td>
                                  </ng-container>

                                  <tr mat-header-row *matHeaderRowDef="['id', 'eid', 'name', 'remove']"></tr>
                                  <tr mat-row *matRowDef="let row; columns: ['id', 'eid', 'name', 'remove'];"
                                      (click)="removeSegment(row)">
                                  </tr>
                              </table>
                          </div>
                          <div class="emptyTableMessage" *ngIf="!showSelectedSegments()">No segments were selected</div>
                      </div>
                  </div>
                  <div class="stepper-actions step2">
                      <button mat-button matStepperNext [disabled]="selectedSegmentsDataSource.data.length === 0">Next
                      </button>
                  </div>
              </mat-step>
              <mat-step>
                  <ng-template matStepLabel>Select target accounts</ng-template>
                  <div>Bulk operation mode</div>
                  <mat-button-toggle-group style="margin: 10px; width: 100%; justify-content: center" name="fontStyle"
                                           aria-label="Font Style"
                                           [value]="bulkOperationMode"
                                           (change)="changeOperationMode($event)">
                      <mat-button-toggle class="operation-mode" *ngFor="let mode of ['SHARE', 'UNSHARE']"
                                         [value]="mode">{{mode | titlecase}}</mat-button-toggle>
                  </mat-button-toggle-group>
                  <div *ngIf="stepIndex===2" class="rowWrap step3">
                      <div class="rowItem search">
                          <h5>Search target accounts</h5>
                          <mat-form-field *ngIf="accountsLoaded">
                              <input [formControl]="targetAccountsFilterControl" [autofocus]="true" matInput
                                     name="input-target-accounts-search"
                                     placeholder="Search a target account by name"/>
                          </mat-form-field>
                          <div class="tableWrapper">
                              <table mat-table [dataSource]="filteredTargetAccountsDataSource" class="mat-elevation-z0"
                                     *ngIf="showFilteredAccounts()">
                                  <ng-container matColumnDef="targetName">
                                      <th mat-header-cell *matHeaderCellDef> Target Group</th>
                                      <td mat-cell *matCellDef="let element"> {{element['targetName']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="accountName">
                                      <th mat-header-cell *matHeaderCellDef> Account Name</th>
                                      <td mat-cell *matCellDef="let element"> {{element['accountName']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="add">
                                      <th mat-header-cell *matHeaderCellDef></th>
                                      <td mat-cell *matCellDef="let element" class="listAction">
                                          <mat-icon matTooltip="Select Account">add</mat-icon>
                                      </td>
                                  </ng-container>

                                  <tr mat-header-row *matHeaderRowDef="['targetName', 'accountName', 'add']"></tr>
                                  <tr mat-row *matRowDef="let row; columns: ['targetName', 'accountName', 'add'];"
                                      (click)="addAccount(row)"></tr>
                              </table>
                          </div>
                          <div class="emptyTableMessage" *ngIf="!showFilteredAccounts() && accountsLoaded">No accounts
                              found
                          </div>
                          <mat-spinner *ngIf="!accountsLoaded"></mat-spinner>
                      </div>
                      <div class="rowItem select">
                          <h5>Selected target accounts ({{selectedTargetAccountsDataSource.data.length}})</h5>
                          <div class="tableWrapper selectedItems">
                              <table mat-table [dataSource]="selectedTargetAccountsDataSource" class="mat-elevation-z0"
                                     *ngIf="showSelectedAccounts()">
                                  <ng-container matColumnDef="targetName">
                                      <th mat-header-cell *matHeaderCellDef> Target Group</th>
                                      <td mat-cell *matCellDef="let element"> {{element['targetName']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="accountName">
                                      <th mat-header-cell *matHeaderCellDef> Account Name</th>
                                      <td mat-cell *matCellDef="let element"> {{element['accountName']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="remove">
                                      <th mat-header-cell *matHeaderCellDef></th>
                                      <td mat-cell *matCellDef="let element" class="listAction">
                                          <mat-icon matTooltip="Remove Segment">remove</mat-icon>
                                      </td>
                                  </ng-container>

                                  <tr mat-header-row *matHeaderRowDef="['targetName', 'accountName', 'remove']"></tr>
                                  <tr mat-row *matRowDef="let row; columns: ['targetName', 'accountName', 'remove'];"
                                      (click)="removeAccount(row)"></tr>
                              </table>
                          </div>
                          <div class="emptyTableMessage" *ngIf="!showSelectedAccounts()">No accounts were selected</div>
                      </div>
                  </div>
                  <div class="stepper-actions step3">
                      <button mat-button matStepperPrevious>Back</button>
                      <button mat-button matStepperNext (click)="accountsSelectedNextClick()"
                              [disabled]="selectedSegmentsDataSource.data.length === 0 ||
                     selectedTargetAccountsDataSource.data.length === 0 || loading">
                          Next
                      </button>
                  </div>
              </mat-step>
              <mat-step [completed]="isConfigurationStepCompleted()">
                  <ng-container *ngIf="shouldShowConfigurationStep()">
                      <ng-template matStepLabel>Configure target accounts</ng-template>
                      <mat-accordion *ngIf="stepIndex===3" class="accountConfigs step4" multi="false">
                          <div *ngFor="let account of selectedTargetAccountsDataSource.data; let i = index"
                               [attr.data-index]="i">
                              <ng-container>
                                  <div *ngIf="account.targetId === TargetSystemId.GOOGLE_DDP">
                                      <mat-expansion-panel [expanded]="i===0">
                                          <mat-expansion-panel-header>{{account.accountName}}</mat-expansion-panel-header>
                                          <app-segment-info-google-ddp
                                                  [account]="distributionAccountModelFromDisplayAccount(account)"
                                                  (priceChange)="onAdditionalSharingConfigChange(targetSystem.GOOGLE,account.accountId,$event)">

                                          </app-segment-info-google-ddp>
                                      </mat-expansion-panel>
                                  </div>

                                  <div *ngIf="account.targetId === TargetSystemId.ACTIVE_AGENT">
                                      <mat-expansion-panel [expanded]="i===0">
                                          <mat-expansion-panel-header>{{account.accountName}}</mat-expansion-panel-header>
                                          <app-segment-info-target-active-agent
                                                  [account]="distributionAccountModelFromDisplayAccount(account)"
                                                  (priceChange)="onAdditionalSharingConfigChange(targetSystem.ACTIVE_AGENT,account.accountId,$event)">

                                          </app-segment-info-target-active-agent>
                                      </mat-expansion-panel>
                                  </div>

                                  <div
                                          *ngIf="account.targetId === TargetSystemId.XANDR || account.targetId === TargetSystemId.XANDR_CRTT">
                                      <mat-expansion-panel [expanded]="i===0">
                                          <mat-expansion-panel-header>{{account.accountName}}</mat-expansion-panel-header>
                                          <app-account-xandr
                                                  [account]="distributionAccountModelFromDisplayAccount(account)"
                                                  (priceChange)="onAdditionalSharingConfigChange(targetSystem.XANDR,account.accountId,$event)">
                                          </app-account-xandr>
                                      </mat-expansion-panel>
                                  </div>

                                  <div *ngIf="account.targetId === TargetSystemId.TTD || account.targetId === TargetSystemId.TTD_DATA_ALLIANCE">
                                      <mat-expansion-panel [expanded]="i===0">
                                          <mat-expansion-panel-header>{{account.accountName}}</mat-expansion-panel-header>
                                          <app-segment-info-target-ttd
                                                  [segments]="selectedSegmentsDataSource.data"
                                                  [account]="distributionAccountModelFromDisplayAccount(account)"
                                                  (configChange)="onAdditionalSharingConfigChange(targetSystem.THE_TRADE_DESK,account.accountId,$event)">
                                          </app-segment-info-target-ttd>
                                      </mat-expansion-panel>
                                  </div>

                                  <div
                                          *ngIf="account.targetId === TargetSystemId.PUBMATIC || account.targetId === TargetSystemId.PUBMATIC_CRTT">
                                      <mat-expansion-panel [expanded]="i===0">
                                          <mat-expansion-panel-header>{{account.accountName}}</mat-expansion-panel-header>
                                          <app-account-pubmatic
                                                  [account]="distributionAccountModelFromDisplayAccount(account)"
                                                  [target]="account.targetId"
                                                  (configChange)="onAdditionalPubmaticSharingConfigChange(account.accountId,$event)">

                                          </app-account-pubmatic>
                                      </mat-expansion-panel>
                                  </div>

                              </ng-container>
                          </div>
                      </mat-accordion>
                      <span *ngIf="stepIndex===3" class="noAccountConfigs info step4">
                <span
                        class="material-icons">info</span> No further configuration for any selected account possible.</span>

                      <div class="error validation-error" style="margin-top: 10px; max-width: unset;"
                           *ngFor="let hint of accountValidationHints()">{{hint}}</div>
                  </ng-container>
                  <div class="stepper-actions step4">
                      <button mat-button matStepperPrevious>Back</button>
                      <button id="step4-next-btn" [disabled]="!accountsValid()" mat-button matStepperNext>Next
                      </button>
                  </div>
              </mat-step>
              <mat-step>
                  <ng-template matStepLabel>{{getLastStepTitle()}}</ng-template>
                  <div *ngIf="!processing" class="rowWrap step5">
                      <div class="rowItem">
                          <h5>Selected segments ({{selectedSegmentsDataSource.data.length}})</h5>
                          <div class="tableWrapper">
                              <table mat-table [dataSource]="selectedSegmentsDataSource" class="mat-elevation-z0"
                                     *ngIf="showSelectedSegments()">
                                  <ng-container matColumnDef="id">
                                      <th mat-header-cell *matHeaderCellDef> Id</th>
                                      <td mat-cell *matCellDef="let element"> {{element['id']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="eid">
                                      <th mat-header-cell *matHeaderCellDef> eId</th>
                                      <td mat-cell *matCellDef="let element"> {{element['clientSideId']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="name">
                                      <th mat-header-cell *matHeaderCellDef> Name</th>
                                      <td mat-cell *matCellDef="let element"> {{element['name']}} </td>
                                  </ng-container>

                                  <tr mat-header-row *matHeaderRowDef="['id', 'eid', 'name']"></tr>
                                  <tr mat-row *matRowDef="let row; columns: ['id', 'eid', 'name'];"></tr>
                              </table>
                          </div>
                      </div>
                      <div class="rowItem">
                          <h5>Selected accounts ({{selectedTargetAccountsDataSource.data.length}})</h5>
                          <div class="tableWrapper">
                              <table mat-table [dataSource]="selectedTargetAccountsDataSource" class="mat-elevation-z0">
                                  <ng-container matColumnDef="targetName">
                                      <th mat-header-cell *matHeaderCellDef> Target Group</th>
                                      <td mat-cell *matCellDef="let element"> {{element['targetName']}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="accountName">
                                      <th mat-header-cell *matHeaderCellDef> Account Name</th>
                                      <td mat-cell *matCellDef="let element"> {{element['accountName']}} </td>
                                  </ng-container>

                                  <tr mat-header-row *matHeaderRowDef="['targetName', 'accountName']"></tr>
                                  <tr mat-row *matRowDef="let row; columns: ['targetName', 'accountName'];"></tr>
                              </table>
                          </div>
                      </div>
                  </div>
                  <small *ngIf="!processing" class="message">
                      <span class="material-icons">info</span> Please note that segments that were already shared to an
                      account
                      will
                      not be shared again, they will be ignored
                  </small>

                  <div *ngIf="processing" class="rowWrap step5">

                      <div style="width:80%" class="rowItem">

                          <h5>Results ({{processingResults.length}})</h5>
                          <div class="tableWrapper">
                              <app-multishare-history-entry
                                      [shareResults]="processingResults"></app-multishare-history-entry>
                          </div>
                      </div>
                      <div style="width:20%; padding-top: 100px; padding-left:20px">
                          <mat-progress-spinner
                                  class="example-margin"
                                  [mode]="processingResults.length?'determinate':'indeterminate'"
                                  [value]="processingProgress*100">
                          </mat-progress-spinner>
                      </div>
                  </div>

                  <div class="stepper-actions step5">
                      <button mat-button matStepperPrevious>Back</button>
                      <button mat-raised-button class="save" color="primary"
                              [disabled]="selectedSegmentsDataSource.data.length === 0 || processing
                    || selectedTargetAccountsDataSource.data.length === 0 || loading"
                              (click)="bulkOperation()">{{getLastStepTitle()}}
                      </button>
                  </div>
              </mat-step>
          </mat-horizontal-stepper>
      </div>
  `,
  styleUrls: ['./segments-multi-share.component.scss']
})
export class SegmentsMultiShareComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly TargetSystemId = TargetSystemId;
  filteredSegmentsDataSource = new MatTableDataSource<Segment>();
  selectedSegmentsDataSource = new MatTableDataSource<Segment>();
  filteredTargetAccountsDataSource = new MatTableDataSource<TargetAccountForDisplay>();
  selectedTargetAccountsDataSource: MatTableDataSource<TargetAccountForDisplay> = new MatTableDataSource<TargetAccountForDisplay>();
  segmentsFilterControl = new FormControl();
  targetAccountsFilterControl = new FormControl();
  partnerSelectedControl = new FormControl();
  loading = true;
  partner!: PartnerModel;
  @ViewChild('stepper') stepper!: MatStepper;
  stepIndex!: number;
  accountsLoaded!: boolean;
  processing = false;
  processingResults: ShareResult[] = [];
  processingProgress = 0;
  processingDataSource = new MatTableDataSource<ShareResult>();
  targetSystem = TargetSystem;
  subSink = new SubSink();
  bulkOperationMode: 'SHARE' | 'UNSHARE' = 'SHARE';
  private allSegmentsSource = new ReplaySubject<Segment[]>(1);
  private allTargetAccountsSource = new ReplaySubject<TargetAccountForDisplay[]>(1);
  private accountSearchTermSource = new BehaviorSubject('');
  private segmentSearchTermSource = new BehaviorSubject('');

  constructor(
    private segmentService: SegmentService,
    private targetService: TargetService,
    private segmentShareService: SegmentShareService,
    private notificationService: NotificationService,
    private appStore: AppStore,
    private store: Store,
    private validationService: MultiShareValidationService) {
  }

  private static sortBySegmentIdDescComparator(a: SegmentModel, b: SegmentModel) {
    return (a.id > b.id ? -1 : 1);
  }

  private static sortByTargetNameAscComparator(a: TargetAccountForDisplay, b: TargetAccountForDisplay) {
    return (a.targetName > b.targetName ? 1 : -1);
  }

  ngOnDestroy(): void {
    if (this.subSink.sink) {
      this.subSink.unsubscribe();
    }
    window.onbeforeunload = null;
  }

  ngOnInit(): void {
    this.validationService.init();

    this.subSink.sink = this.appStore.subscribe((state: AppStore) => {
      const user = userSelector(state);
      const partner = partnerForIdSelector(state, user.partnerId);
      if (partner && this.partner !== partner) {
        this.partner = partner;
        this.loadData();
      }
    });

    this.subSink.sink = this.segmentsFilterControl.valueChanges.subscribe(searchTerm => {
      this.segmentSearchTermSource.next(searchTerm);
    });

    this.subSink.sink = this.targetAccountsFilterControl.valueChanges.subscribe(searchTerm => {
      this.accountSearchTermSource.next(searchTerm);
    });

    this.subSink.sink = combineLatest([
      this.segmentShareService.selectedSegments,
      this.segmentShareService.selectedTargetAccounts,
      this.allSegmentsSource,
      this.allTargetAccountsSource])
      .subscribe(([segmentIds, accountIds, allSegments, allAccounts]) => {
        this.selectedSegmentsDataSource.data = segmentIds
          .map(id => allSegments.find((segment) => segment.id === id) as Segment)
          .filter(it => it && it.id)
          .sort(SegmentsMultiShareComponent.sortBySegmentIdDescComparator) as Segment[];

        this.selectedTargetAccountsDataSource.data = accountIds
          .map(id => allAccounts.find((account) => account.accountId === id) as TargetAccountForDisplay)
          .sort(SegmentsMultiShareComponent.sortByTargetNameAscComparator) as TargetAccountForDisplay[];
      });

    this.subSink.sink = combineLatest([
      this.allTargetAccountsSource,
      this.accountSearchTermSource,
      this.segmentShareService.selectedTargetAccounts])
      .subscribe(([allAccounts, searchTerm, selectedAccountIds]) => {
        this.accountsLoaded = true;
        this.filteredTargetAccountsDataSource.data = allAccounts.filter(account => {
          // Filter already selected ones out
          if (selectedAccountIds.includes(account.accountId)) {
            return false;
          }

          return searchTerm
            ? account.targetName.toLowerCase().includes(searchTerm.toLowerCase())
            || account.accountName.toLowerCase().includes(searchTerm.toLowerCase())
            : true;
        });
      });

    this.subSink.sink = combineLatest([
      this.allSegmentsSource,
      this.segmentSearchTermSource,
      this.segmentShareService.selectedSegments])
      .subscribe(([allSegments, searchTerm, selectedAccountIds]) => {
        this.filteredSegmentsDataSource.data = allSegments.filter(segment => {
          // Filter already selected ones out
          if (selectedAccountIds.includes(segment.id)) {
            return false;
          }
          return searchTerm
            ? segment.id.toString().includes(searchTerm)
            || segment.name.toLowerCase().includes(searchTerm.toLowerCase())
            || (segment.clientSideId && segment.clientSideId.includes(searchTerm))
            : true;
        });
      });
    window.onbeforeunload = (ev) => {
      ev.returnValue = 'Are you sure you wish to leave multishare?';
    };
  }

  ngAfterViewInit(): void {
    this.subSink.sink = combineLatest([this.segmentShareService.selectedSegments, this.segmentShareService.selectedTargetAccounts])
      .pipe(first())
      .subscribe(([segmentIds, accountIds]) => {
        setTimeout(() => {
          if (segmentIds.length > 0 && accountIds.length > 0) {
            this.moveToStep(3);
          } else if (segmentIds.length > 0) {
            this.moveToStep(2);
          }
        }, 1);
      });
  }

  accountsValid(): boolean {
    return this.validationService.isValid();
  }

  accountValidationHints(): string[] {
    return this.validationService.errorHints() as string[];
  }

  distributionAccountModelFromDisplayAccount(account: TargetAccountForDisplay) {
    return new DistributionAccountModel({
      description: account.accountName,
      id: account.accountId,
      foreignAccountId: account.foreignAccountId,
      apiId: account.apiId
    } as DistributionAccountModel);
  }

  addSegment(segment: SegmentModel) {
    this.segmentShareService.addSegmentToSelection(segment.id);
  }

  removeSegment(segment: SegmentModel) {
    this.segmentShareService.removeSegmentFromSelection(segment.id);
  }

  reset() {
    this.segmentShareService.reset();
    this.segmentsFilterControl.setValue('');
    this.targetAccountsFilterControl.setValue('');
    this.partnerSelectedControl.setValue(false);
    if (this.stepper) {
      this.stepper.reset();
    }
  }

  bulkOperation() {
    this.processing = true;
    this.subSink.sink = this.segmentShareService.bulkOperation(this.bulkOperationMode)
      .subscribe((next: { shareResults: ShareResult[], expectedShareResultsCount: number }) => {
        const currentResults = next?.shareResults.map(item => {
          // for each result (step1 or step2) give specific feedback for segmentId / accountId combination
          return {
            segmentId: item.segmentId,
            accountName: this.selectedTargetAccountsDataSource.data
              .find(row => row.accountId === item.accountId)?.accountName || '#' + item.accountId,
            shareMessages: item.shareMessages
          } as ShareResult;
        });
        this.processingResults = [...currentResults];
        this.processingProgress = (this.processingResults.length / next.expectedShareResultsCount);
      });
  }

  showFilteredSegments() {
    return this.filteredSegmentsDataSource.data.length > 0;
  }

  showSelectedSegments() {
    return this.selectedSegmentsDataSource.data.length > 0;
  }

  addAccount(account: TargetAccountForDisplay) {
    this.segmentShareService.addAccountToSelection(account.accountId);
  }

  removeAccount(account: TargetAccountForDisplay) {
    this.segmentShareService.removeAccountFromSelection(account.accountId);
  }

  showFilteredAccounts() {
    return this.filteredTargetAccountsDataSource.data.length > 0;
  }

  showSelectedAccounts() {
    return this.selectedTargetAccountsDataSource.data.length > 0;
  }

  onStep($event: StepperSelectionEvent) {
    this.stepIndex = $event.selectedIndex;
    if ($event.previouslySelectedIndex === 4) {
      this.processing = false;
      this.processingResults = [];
    }
  }

  onAdditionalPubmaticSharingConfigChange(accountId: number,
                                          config: PubmaticEditConfig) {
    this.onAdditionalSharingConfigChange(TargetSystem.PUBMATIC, accountId, {
      price: config.price,
      buyers: config.buyers.map(buyer => ({id: buyer.id, type: 'BUYER', deleted: false}))
    } as PubmaticShareConfig);
  }

  onAdditionalSharingConfigChange(targetSystem: TargetSystem,
                                  accountId: number,
                                  config: AdditionalSharingConfigBase) {
    this.segmentShareService.addAccountDetailConfiguration(
      targetSystem,
      accountId,
      config
    );
  }

  isConfigurationStepCompleted(): boolean {
    return this.accountsValid() || (this.bulkOperationMode === 'UNSHARE');
  }

  shouldShowConfigurationStep(): boolean {
    return this.bulkOperationMode === 'SHARE';
  }

  getLastStepTitle(): string {
    if (this.bulkOperationMode === 'SHARE') {
      return 'Share segments';
    } else if (this.bulkOperationMode === 'UNSHARE') {
      return 'Unshare segments';
    }
    return '';
  }

  changeOperationMode($event: MatButtonToggleChange) {
    this.bulkOperationMode = $event.value;
  }

  accountsSelectedNextClick() {
    if (this.bulkOperationMode === 'UNSHARE') {
      this.stepper.selectedIndex = 4;
    }
  }

  private loadData() {
    this.loading = true;
    this.subSink.sink = this.segmentService.getAllSegments()
      .subscribe({
        next: data => {
          this.allSegmentsSource.next(data);
          this.segmentSearchTermSource.next('');
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.notificationService.error('Error loading segments');
        }
      });

    this.subSink.sink = this.store.select(selectTargets)
      .subscribe({
        next: data => {
          const targets = data
            .sort((t1, t2) => t1.targetName > t2.targetName ? 1 : -1); // sort by name asc

          const allAccounts: any[] = [];
          targets.forEach(target => {
            target.accounts.forEach(acc => {
              allAccounts.push({
                targetId: target.targetId,
                targetName: target.targetName,
                foreignAccountId: acc.foreignAccountId,
                accountName: acc.description,
                accountId: acc.id,
                apiId: acc.apiId
              });
            });
          });
          this.allTargetAccountsSource.next(allAccounts);
          this.accountSearchTermSource.next('');
        },
        error: () => {
          this.notificationService.error('Error loading targets');
        }
      });
  }

  private moveToStep(stepIdx: number) {
    this.stepper.steps.forEach((step, idx) => {

      if (idx < stepIdx) {
        step.completed = true;
      } else if (idx === stepIdx) {
        step.select();
      }
    });
  }
}
